import { MetadataItem } from "components/MetadataCard";
import { useRunningTime } from "hooks";
import { string } from "utils";

const { msToDuration } = string;

interface RuntimeTimerProps {
  startTime: Date;
}
export const RuntimeTimer: React.FC<RuntimeTimerProps> = ({ startTime }) => {
  const parsedStartTime = new Date(startTime);

  const { runningTime } = useRunningTime(parsedStartTime);

  return (
    <MetadataItem data-testid="task-metadata-running-time" label="Running time">
      {msToDuration(runningTime)}
    </MetadataItem>
  );
};
